import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
/*eslint-disable*/
import request from '@/utils/request';
import * as tree from '@/utils/tree';
export function getDepts(params) {
  return request({
    url: 'api/dept',
    method: 'get',
    params: params
  });
}
export function add(data) {
  return request({
    url: 'api/dept',
    method: 'post',
    data: data
  });
}
export function del(ids) {
  return request({
    url: 'api/dept',
    method: 'delete',
    data: ids
  });
}
export function edit(data) {
  return request({
    url: 'api/dept',
    method: 'put',
    data: data
  });
}
export function detail(id) {
  return request({
    url: 'api/dept/detail',
    method: 'post',
    data: {
      id: id
    }
  });
}
export function selectDept(data) {
  return request({
    url: 'api/dept/select',
    method: 'post',
    data: data
  });
}
export function loadCompanyDeptData() {
  return _loadCompanyDeptData.apply(this, arguments);
}
function _loadCompanyDeptData() {
  _loadCompanyDeptData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var companyId,
      areaId,
      companyIds,
      data,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          companyId = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
          areaId = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
          companyIds = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
          _context.prev = 3;
          _context.next = 6;
          return selectDept({
            companyId: companyId,
            areaId: areaId,
            companyIds: companyIds
          });
        case 6:
          data = _context.sent;
          return _context.abrupt("return", tree.formatTreeNode(data || []));
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](3);
          return _context.abrupt("return", []);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 10]]);
  }));
  return _loadCompanyDeptData.apply(this, arguments);
}
export default {
  add: add,
  edit: edit,
  del: del,
  detail: detail,
  getDepts: getDepts,
  selectDept: selectDept,
  loadCompanyDeptData: loadCompanyDeptData
};